import React from 'react'

const ParamContext = React.createContext({
  q: '',
  setQ: () => {},
  archived: false,
  setArchived: () => {},
})

export default ParamContext